import React from 'react';
import { GitCommit, Search, MessageSquare, Award, FileCheck } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
  {
    icon: GitCommit,
    title: "Architected Tasks",
    description: "Tasks are architected and version-controlled. No busy work, only structured development units."
  },
  {
    icon: Search,
    title: "Defined Reviews",
    description: "Submissions are reviewed against defined industry standards before acceptance."
  },
  {
    icon: MessageSquare,
    title: "Structured Feedback",
    description: "Mentors provide structured, documented feedback loops for every sprint cycle."
  },
  {
    icon: Award,
    title: "Merit-Based",
    description: "Progression is purely merit-based. Status is earned through approved commits."
  },
  {
    icon: FileCheck,
    title: "Verifiable History",
    description: "Contribution history is documented, creating a permanent technical footprint."
  }
];

const TheModel = () => {
  return (
    <section id="model" className="py-24 bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">The Model</h2>
          <p className="text-lg text-slate-600 max-w-3xl">
            InternStacks functions as a contribution-driven development environment. 
            Participants are placed into live project cycles where governance dictates workflow.
            Every intern operates within a governed system — not a casual workspace.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white p-8 border border-slate-200 rounded-sm hover:border-slate-400 transition-colors"
            >
              <feature.icon className="w-8 h-8 text-slate-800 mb-6" strokeWidth={1.5} />
              <h3 className="text-xl font-semibold text-slate-900 mb-3">{feature.title}</h3>
              <p className="text-slate-600 leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TheModel;
